<script setup>
const content = `De schaal Initiatief omschrijft in hoeverre iemand vernieuwend denkt en de energie heeft om zijn/haar ideeën tot uitvoering te brengen.<br> Hoogscoorders op deze schaal hebben veel ideeën en weten deze met vertrouwen en enthousiasme aan anderen over te brengen. <br> Iemand die laag scoort op deze schaal houdt liever vast aan werkwijzen die zich in het verleden bewezen hebben in plaats van steeds met nieuwe plannen te komen.`
</script>

<template>
  <div class="">
    <InfoTippy :content />
  </div>
</template>
